import { computed } from 'mobx';
import ArrayListenerState from '../../abstract/ArrayListenerState';
import LandlordPropertyState from './LandlordPropertyState';

class PropertiesState extends ArrayListenerState {
  constructor(root) {
    super(root, {
      expression: () => this.root.publicAccount.data.landlordPropertyUids,
      ItemClass: LandlordPropertyState,
    });
  }

  get tenanciesCount() {
    return this.isInitialized
      ? this.data?.reduce((acc, propertyDoc) => {
          return acc + (propertyDoc.tenancies.data?.length || 0);
        }, 0)
      : 0;
  }

  get tenanciesCountOccupied() {
    return this.isInitialized
      ? this.data.reduce((acc, propertyDoc) => {
          const occupiedTenancies = propertyDoc.tenancies.isInitialized
            ? propertyDoc.tenancies.data.filter(
                ({ error, data }) => !error && data.propertyIsOccupied
              ).length
            : 0;

          return acc + occupiedTenancies;
        }, 0)
      : 0;
  }

  get occupancyValue() {
    return this.tenanciesCount
      ? Math.round((this.tenanciesCountOccupied / this.tenanciesCount) * 100)
      : 0;
  }
}

PropertiesState.annotations = {
  ...ArrayListenerState.annotations,
  tenanciesCount: computed,
  tenanciesCountOccupied: computed,
  occupancyValue: computed,
};

export default PropertiesState;
